import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Grid2,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import CelebrationIcon from '@mui/icons-material/Celebration';

export default function Dashboard() {
  return (
    <Grid2 container>
      <Grid2 offset={2} size={8}>
        <Card variant="outlined">
          <CardHeader
            disableTypography
            title={
              <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center' }}>
                <CelebrationIcon sx={{ mr: 2 }} />
                Welcome to OpenGolfSim!
              </Typography>
            }
          />
          <CardContent sx={{ py: 2, minHeight: 100 }}>
            <Typography>Just starting out? Checkout our getting started guide for tips to help you get started with the app. Learn more about setting up control devices, shot replay, and more!</Typography>
          </CardContent>
          <CardActions>
            <Button fullWidth href="https://help.opengolfsim.com/desktop/quick-start-guide" target="_blank">Quick Start Guide</Button>
          </CardActions>
        </Card>

      </Grid2>
    </Grid2>    
  )
}